module.exports = __webpack_public_path__ + "leftCircleActive.33b74c91.png";